module.exports = __webpack_public_path__ + "img/profile.9a43e07b.svg";